import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { ThemeCustomizerService } from '../../common/theme-customizer/theme-customizer.service';

interface FacultyRow {
  sno: number;
  auFin: string;
  aicteId: string;
  nameDesignation: string;
  department: string;
  photoPath: string;
}

@Component({
  selector: 'app-category-page-three',
  templateUrl: './category-page-three.component.html',
  styleUrls: ['./category-page-three.component.scss']
})
export class CategoryPageThreeComponent implements OnInit, OnDestroy {
  isToggled = false;
  private themeSub?: Subscription;

  facultyList: FacultyRow[] = [
    {
      sno: 1,
      auFin: "2682431967",
      aicteId: "1-454105318",
      nameDesignation: "Dr.P.Nelson Raja Principal & Prof/Thermal",
      department: "",
      photoPath: "assets/img/faculty/faculty-001.jpg"
    },
    {
      sno: 2,
      auFin: "2664871982",
      aicteId: "1-4566664702",
      nameDesignation: "Dr.P.Velumani, Prof/Civil",
      department: "B.E CIVIL ENGINEERING",
      photoPath: "assets/img/faculty/faculty-002.jpg"
    },
    {
      sno: 3,
      auFin: "2680921989",
      aicteId: "1-2477103543",
      nameDesignation: "Mr.M.J.Thavaseelan, ASP/ Civil",
      department: "B.E CIVIL ENGINEERING",
      photoPath: "assets/img/faculty/faculty-003.jpg"
    },
    {
      sno: 4,
      auFin: "2655301988",
      aicteId: "1-1476246163",
      nameDesignation: "Mr..G.Alagumurugan,ASP/ Civil",
      department: "B.E CIVIL ENGINEERING",
      photoPath: "assets/img/faculty/faculty-004.jpg"
    },
    {
      sno: 5,
      auFin: "2619451992",
      aicteId: "1-3202465624",
      nameDesignation: "Mr.P.Jeyakumar,AP/ Civil",
      department: "B.E CIVIL ENGINEERING",
      photoPath: "assets/img/faculty/faculty-005.jpg"
    },
    {
      sno: 6,
      auFin: "2618941995",
      aicteId: "1-7421731262",
      nameDesignation: "Mr.A.Bharath kumar,AP/Civil",
      department: "B.E CIVIL ENGINEERING",
      photoPath: "assets/img/faculty/faculty-006.jpg"
    },
    {
      sno: 7,
      auFin: "2614921978",
      aicteId: "1-751461225",
      nameDesignation: "Dr. P. Ravikumaran, Prof/CSE", 
      department: "B.E COMPUTER SCIENCE & ENGINEERING",
      photoPath: "assets/img/faculty/faculty-007.jpg"
    },
    {
      sno: 8,
      auFin: "2680071981",
      aicteId: "1-45031388582",
      nameDesignation: "Ms. I.G Umamaheswari, ASP/CSE",
      department: "B.E COMPUTER SCIENCE & ENGINEERING",
      photoPath: "assets/img/faculty/faculty-008.jpg"
    },
    {
      sno: 9,
      auFin: "2692351995",
      aicteId: "1-44720479271",
      nameDesignation: "Ms. K. Sangeetha, AP/CSE",
      department: "B.E COMPUTER SCIENCE & ENGINEERING",
      photoPath: "assets/img/faculty/faculty-009.jpg"
    },
    {
      sno: 10,
      auFin: "2684051989",
      aicteId: "1-44789206194",
      nameDesignation: "Ms. D. Vijayalakshmi, AP/CSE",
      department: "B.E COMPUTER SCIENCE & ENGINEERING",
      photoPath: "assets/img/faculty/faculty-010.jpg"
    },
    {
      sno: 11,
      auFin: "2647492001",
      aicteId: "1-47060989036",
      nameDesignation: "Ms. K. Madhumitha, AP/CSE",
      department: "B.E COMPUTER SCIENCE & ENGINEERING",
      photoPath: "assets/img/faculty/faculty-011.jpg"
    },
    {
      sno: 12,
      auFin: "2632291993",
      aicteId: "1-45301388592",
      nameDesignation: "Ms. S. Vinothini, AP/CSE",
      department: "B.E COMPUTER SCIENCE & ENGINEERING",
      photoPath: "assets/img/faculty/faculty-012.jpg"
    },
    {
      sno: 13,
      auFin: "2622791997",
      aicteId: "1-44789243454",
      nameDesignation: "Mr. B. Yasar, AP/CSE",
      department: "B.E COMPUTER SCIENCE & ENGINEERING",
      photoPath: "assets/img/faculty/faculty-013.jpg"
    },
    {
      sno: 14,
      auFin: "2685161996",
      aicteId: "1-44720479374",
      nameDesignation: "Ms. P.K Salomi Victoria, AP/CSE",
      department: "B.E COMPUTER SCIENCE & ENGINEERING",
      photoPath: "assets/img/faculty/faculty-014.jpg"
    },
    {
      sno: 15,
      auFin: "2633282000",
      aicteId: "1-4561444785",
      nameDesignation: "Ms. D. Thenmozhi, AP/CSE",
      department: "B.E COMPUTER SCIENCE & ENGINEERING",
      photoPath: "assets/img/faculty/faculty-015.jpg"
    },
    {
      sno: 16,
      auFin: "2641261998",
      aicteId: "1-44785987854",
      nameDesignation: "Ms. M. Senthilkumari, AP/CSE",
      department: "B.E COMPUTER SCIENCE & ENGINEERING",
      photoPath: "assets/img/faculty/faculty-016.jpg"
    },
    {
      sno: 17,
      auFin: "2655451971",
      aicteId: "1-7481227158",
      nameDesignation: "Mr.G.Balakrishnan,ASP/AIML",
      department: "B.E COMPUTER SCIENCE & ENGINEERING (ARTIFICIAL INTELLIGENCE & MACHINE LEARNING)",
      photoPath: "assets/img/faculty/faculty-017.jpg"
    },
    {
      sno: 18,
      auFin: "2665111987",
      aicteId: "1-727556118",
      nameDesignation: "Mrs.S.Valli Mayil, AP/AIML",
      department: "B.E COMPUTER SCIENCE & ENGINEERING (ARTIFICIAL INTELLIGENCE & MACHINE LEARNING)",
      photoPath: "assets/img/faculty/faculty-018.jpg"
    },
    {
      sno: 19,
      auFin: "2684471993",
      aicteId: "1-7517015995",
      nameDesignation: "Mr.V.Marees kannan, AP/AIML",
      department: "B.E COMPUTER SCIENCE & ENGINEERING (ARTIFICIAL INTELLIGENCE & MACHINE LEARNING)",
      photoPath: "assets/img/faculty/faculty-019.jpg"
    },
    {
      sno: 20,
      auFin: "2652631995",
      aicteId: "1-44720479326",
      nameDesignation: "Mrs.A.Renisna, AP/AIML",
      department: "B.E COMPUTER SCIENCE & ENGINEERING (ARTIFICIAL INTELLIGENCE & MACHINE LEARNING)",
      photoPath: "assets/img/faculty/faculty-020.jpg"
    },
    {
      sno: 21,
      auFin: "2783342002",
      aicteId: "1-47944828107",
      nameDesignation: "Ms.R.Kaviya, AP/AIML",
      department: "B.E COMPUTER SCIENCE & ENGINEERING (ARTIFICIAL INTELLIGENCE & MACHINE LEARNING)",
      photoPath: "assets/img/faculty/faculty-021.jpg"
    },
    {
      sno: 22,
      auFin: "2647171993",
      aicteId: "1-44721940858",
      nameDesignation: "Mrs.G.Kavery Suba, AP/AIML",
      department: "B.E COMPUTER SCIENCE & ENGINEERING (ARTIFICIAL INTELLIGENCE & MACHINE LEARNING)",
      photoPath: "assets/img/faculty/faculty-022.jpg"
    },
    {
      sno: 23,
      auFin: "2698421989",
      aicteId: "1-47948828192",
      nameDesignation: "Mr.M.Kasi, AP/AIML",
      department: "B.E COMPUTER SCIENCE & ENGINEERING (ARTIFICIAL INTELLIGENCE & MACHINE LEARNING)",
      photoPath: "assets/img/faculty/faculty-023.jpg"
    },
    {
      sno: 24,
      auFin: "2670301987",
      aicteId: "",
      nameDesignation: "Ms.S.Nithya, AP/AIML",
      department: "B.E COMPUTER SCIENCE & ENGINEERING (ARTIFICIAL INTELLIGENCE & MACHINE LEARNING)",
      photoPath: "assets/img/faculty/faculty-024.jpg"
    },
    {
      sno: 25,
      auFin: "2697361981",
      aicteId: "1-491039313",
      nameDesignation: "M.SIVA GANESH ASP/CYBER",
      department: "B.E COMPUTER SCIENCE & ENGINEERING (CYBER SECURITY)",
      photoPath: "assets/img/faculty/faculty-025.jpg"
    },
    {
      sno: 26,
      auFin: "2643621995",
      aicteId: "1-45350946814",
      nameDesignation: "K.APARNA PREETHI AP/CYBER",
      department: "B.E COMPUTER SCIENCE & ENGINEERING (CYBER SECURITY)",
      photoPath: "assets/img/faculty/faculty-026.jpg"
    },
    {
      sno: 27,
      auFin: "2680632002",
      aicteId: "1-46014653432",
      nameDesignation: "G.HEMAVATHI AP/CYBER",
      department: "B.E COMPUTER SCIENCE & ENGINEERING (CYBER SECURITY)",
      photoPath: "assets/img/faculty/faculty-027.jpg"
    },
    {
      sno: 28,
      auFin: "670301987",
      aicteId: "1-43735972103",
      nameDesignation: "R.SUGANYA SUBATHRA AP/CYBER",
      department: "B.E COMPUTER SCIENCE & ENGINEERING (CYBER SECURITY)",
      photoPath: "assets/img/faculty/faculty-028.jpg"
    },
    {
      sno: 29,
      auFin: "2637251995",
      aicteId: "1-47948818432",
      nameDesignation: "T.ARUNA DEVI AP/CYBER",
      department: "B.E COMPUTER SCIENCE & ENGINEERING (CYBER SECURITY)",
      photoPath: "assets/img/faculty/faculty-029.jpg"
    },
    {
      sno: 30,
      auFin: "2632231967",
      aicteId: "1-3564756491",
      nameDesignation: "Dr.A.Yasodai, Prof/ECE",
      department: "B.E ELECTRONICS AND COMMUNICATION ENGINEERING",
      photoPath: "assets/img/faculty/faculty-030.jpg"
    },
    {
      sno: 31,
      auFin: "2676181982",
      aicteId: "1-9461255788",
      nameDesignation: "Mr.M.Elayaraja, ASP/ECE",
      department: "B.E ELECTRONICS AND COMMUNICATION ENGINEERING",
      photoPath: "assets/img/faculty/faculty-031.jpg"
    },
    {
      sno: 32,
      auFin: "2678691987",
      aicteId: "1-2190159814",
      nameDesignation: "Mr.A.K.Palanikumar, ASP/ECE",
      department: "B.E ELECTRONICS AND COMMUNICATION ENGINEERING",
      photoPath: "assets/img/faculty/faculty-032.jpg"
    },
    {
      sno: 33,
      auFin: "2645271984",
      aicteId: "1-7428633365",
      nameDesignation: "Mr.R.Nagadeepa, ASP/ECE",
      department: "B.E ELECTRONICS AND COMMUNICATION ENGINEERING",
      photoPath: "assets/img/faculty/faculty-033.jpg"
    },
    {
      sno: 34,
      auFin: "2617031991",
      aicteId: "1-44720439404",
      nameDesignation: "Mrs.D.Vijitha, AP/ECE",
      department: "B.E ELECTRONICS AND COMMUNICATION ENGINEERING",
      photoPath: "assets/img/faculty/faculty-034.jpg"
    },
    {
      sno: 35,
      auFin: "2682861995",
      aicteId: "1-11084888481",
      nameDesignation: "Mr.P.Jebane, AP/ECE",
      department: "B.E ELECTRONICS AND COMMUNICATION ENGINEERING",
      photoPath: "assets/img/faculty/faculty-035.jpg"
    },
    {
      sno: 36,
      auFin: "2695511996",
      aicteId: "1-11302809815",
      nameDesignation: "Mrs.S.Manisha banu, AP/ECE",
      department: "B.E ELECTRONICS AND COMMUNICATION ENGINEERING",
      photoPath: "assets/img/faculty/faculty-036.jpg"
    },
    {
      sno: 37,
      auFin: "2641861988",
      aicteId: "1-43781579548",
      nameDesignation: "Mrs.A.Asiyamariyam, AP/ECE",
      department: "B.E ELECTRONICS AND COMMUNICATION ENGINEERING",
      photoPath: "assets/img/faculty/faculty-037.jpg"
    },
    {
      sno: 38,
      auFin: "2665401990",
      aicteId: "1-46014653441",
      nameDesignation: "Mrs.N.Thangalakshmi, AP/ECE",
      department: "B.E ELECTRONICS AND COMMUNICATION ENGINEERING",
      photoPath: "assets/img/faculty/faculty-038.jpg"
    },
    {
      sno: 39,
      auFin: "2621001986",
      aicteId: "1-4682719102",
      nameDesignation: "Dr. R.NATARAJAN Prof/EEE",
      department: "B.E ELECTRICAL AND ELECTRONICS ENGINEERING",
      photoPath: "assets/img/faculty/faculty-039.jpg"
    },
    {
      sno: 40,
      auFin: "2697641980",
      aicteId: "1-44723601340",
      nameDesignation: "Dr. M. ARUNRAJA, Prof/EEE",
      department: "B.E ELECTRICAL AND ELECTRONICS ENGINEERING",
      photoPath: "assets/img/faculty/faculty-040.jpg"
    },
    {
      sno: 41,
      auFin: "2667281986",
      aicteId: "1-44726666518",
      nameDesignation: "Mrs.M.MOHAMED AJMAL KHAN, ASP/EEE",
      department: "B.E ELECTRICAL AND ELECTRONICS ENGINEERING",
      photoPath: "assets/img/faculty/faculty-041.jpg"
    },
    {
      sno: 42,
      auFin: "2636801981",
      aicteId: "1-9318799341",
      nameDesignation: "Mrs.B. NOORUL HAMITHA, ASP/EEE",
      department: "B.E ELECTRICAL AND ELECTRONICS ENGINEERING",
      photoPath: "assets/img/faculty/faculty-042.jpg"
    },
    {
      sno: 43,
      auFin: "2643631991",
      aicteId: "1-4682406975",
      nameDesignation: "Mrs.M.AISHWARYA, AP/EEE",
      department: "B.E ELECTRICAL AND ELECTRONICS ENGINEERING",
      photoPath: "assets/img/faculty/faculty-043.jpg"
    },
    {
      sno: 44,
      auFin: "2674171970",
      aicteId: "1-11026301330",
      nameDesignation: "Dr.P.Paulpandian Prof/Mech",
      department: "B.E MECHANICAL ENGINEERING",
      photoPath: "assets/img/faculty/faculty-044.jpg"
    },
    {
      sno: 45,
      auFin: "2636091980",
      aicteId: "1-2191140439",
      nameDesignation: "Mr.M.Prabakaran ASP/Mech",
      department: "B.E MECHANICAL ENGINEERING",
      photoPath: "assets/img/faculty/faculty-045.jpg"
    },
    {
      sno: 46,
      auFin: "2631021986",
      aicteId: "1-1476236397",
      nameDesignation: "Mr.M.Selvakumar AP/Mech",
      department: "B.E MECHANICAL ENGINEERING",
      photoPath: "assets/img/faculty/faculty-046.jpg"
    },
    {
      sno: 47,
      auFin: "2640761984",
      aicteId: "1-2712754203",
      nameDesignation: "Mr.R.Pandi AP/Mech",
      department: "B.E MECHANICAL ENGINEERING",
      photoPath: "assets/img/faculty/faculty-047.jpg"
    },
    {
      sno: 48,
      auFin: "2684571988",
      aicteId: "1-7391488687",
      nameDesignation: "Mr.J.Anandh AP/Mech",
      department: "B.E MECHANICAL ENGINEERING",
      photoPath: "assets/img/faculty/faculty-048.jpg"
    },
    {
      sno: 49,
      auFin: "2693791977",
      aicteId: "1-2712981927",
      nameDesignation: "Dr.S.Saravanakumar Prof/Auto",
      department: "B.E AUTOMOBILE ENGINEERING",
      photoPath: "assets/img/faculty/faculty-049.jpg"
    },
    {
      sno: 50,
      auFin: "2646701978",
      aicteId: "1-2191234679",
      nameDesignation: "Mr.M.Kathiravan AP/Auto",
      department: "B.E AUTOMOBILE ENGINEERING",
      photoPath: "assets/img/faculty/faculty-050.jpg"
    },
    {
      sno: 51,
      auFin: "2660231984",
      aicteId: "1-449843805",
      nameDesignation: "Mr. A. Athimoolam, ASP/Physics",
      department: "SCIENCE AND HUMANITIES",
      photoPath: "assets/img/faculty/faculty-051.jpg"
    },
    {
      sno: 52,
      auFin: "2634111996",
      aicteId: "1-43735652029",
      nameDesignation: "Dr. P. Ajith, AP/Physics",
      department: "SCIENCE AND HUMANITIES",
      photoPath: "assets/img/faculty/faculty-052.jpg"
    },
    {
      sno: 53,
      auFin: "2686851991",
      aicteId: "1-34385965282",
      nameDesignation: "Dr. S. Dheepthi Gunavathana, ASP/Physics",
      department: "SCIENCE AND HUMANITIES",
      photoPath: "assets/img/faculty/faculty-053.jpg"
    },
    {
      sno: 54,
      auFin: "2614011967",
      aicteId: "1-43881467632",
      nameDesignation: "Dr. S. Ramalingam, Prof/Chemistry",
      department: "SCIENCE AND HUMANITIES",
      photoPath: "assets/img/faculty/faculty-054.jpg"
    },
    {
      sno: 55,
      auFin: "2627021990",
      aicteId: "1-437957788278",
      nameDesignation: "Dr.S.Muthupoongodi, ASP/Chemistry",
      department: "SCIENCE AND HUMANITIES",
      photoPath: "assets/img/faculty/faculty-055.jpg"
    },
    {
      sno: 56,
      auFin: "2780921976",
      aicteId: "1-11333208228",
      nameDesignation: "Dr.Sabarimala, Prof/Chemistry",
      department: "SCIENCE AND HUMANITIES",
      photoPath: "assets/img/faculty/faculty-056.jpg"
    },
    {
      sno: 57,
      auFin: "2666881968",
      aicteId: "1-9319350481",
      nameDesignation: "Dr.V.Vasanthi, AP/English",
      department: "SCIENCE AND HUMANITIES",
      photoPath: "assets/img/faculty/faculty-057.jpg"
    },
    {
      sno: 58,
      auFin: "2692621982",
      aicteId: "1-9313269735",
      nameDesignation: "Mrs. P. Navammal, AP/English",
      department: "SCIENCE AND HUMANITIES",
      photoPath: "assets/img/faculty/faculty-058.jpg"
    },
    {
      sno: 59,
      auFin: "2719941983",
      aicteId: "1-11096386524",
      nameDesignation: "Mrs. J. Jeyanthi, AP/English",
      department: "SCIENCE AND HUMANITIES",
      photoPath: "assets/img/faculty/faculty-059.jpg"
    },
    {
      sno: 60,
      auFin: "2664871992",
      aicteId: "1-47948327882",
      nameDesignation: "Dr. Suganya, AP/Maths",
      department: "SCIENCE AND HUMANITIES",
      photoPath: "assets/img/faculty/faculty-060.jpg"
    },
    {
      sno: 61,
      auFin: "2791451999",
      aicteId: "1-44788706707",
      nameDesignation: "Dr. J. Celin Fiona, AP/Maths",
      department: "SCIENCE AND HUMANITIES",
      photoPath: "assets/img/faculty/faculty-061.jpg"
    },
    {
      sno: 62,
      auFin: "2654151983",
      aicteId: "1-732816138",
      nameDesignation: "Mr.B.Selvakumar, ASP/Maths",
      department: "SCIENCE AND HUMANITIES",
      photoPath: "assets/img/faculty/faculty-062.jpg"
    },
    {
      sno: 63,
      auFin: "2711821985",
      aicteId: "1-43891742201",
      nameDesignation: "Mr.R.Prabakaran, AP/Maths",
      department: "SCIENCE AND HUMANITIES",
      photoPath: "assets/img/faculty/faculty-063.jpg"
    },
    {
      sno: 64,
      auFin: "2747021993",
      aicteId: "1-47044824614",
      nameDesignation: "Mrs.M.Harini, AP/Maths",
      department: "SCIENCE AND HUMANITIES",
      photoPath: "assets/img/faculty/faculty-064.jpg"
    },
    {
      sno: 65,
      auFin: "2621941988",
      aicteId: "1-43880244066",
      nameDesignation: "Mr.Prabhu, AP/EEE",
      department: "GENERAL ENGINEERING",
      photoPath: "assets/img/faculty/faculty-065.jpg"
    },
    {
      sno: 66,
      auFin: "2644142001",
      aicteId: "1-45350946782",
      nameDesignation: "Ms.J.Bastina Renita, AP/ECE",
      department: "GENERAL ENGINEERING",
      photoPath: "assets/img/faculty/faculty-066.jpg"
    },
    {
      sno: 67,
      auFin: "2632621993",
      aicteId: "1-47948725993",
      nameDesignation: "Mr. C. Daniel Antony, AP/Mech",
      department: "GENERAL ENGINEERING",
      photoPath: "assets/img/faculty/faculty-067.jpg"
    },
    {
      sno: 68,
      auFin: "2651141993",
      aicteId: "1-44720425958",
      nameDesignation: "Mr. S. Vignesh Karthick, AP/Civil",
      department: "GENERAL ENGINEERING",
      photoPath: "assets/img/faculty/faculty-068.jpg"
    },
    {
      sno: 69,
      auFin: "2689921985",
      aicteId: "1-3205103158",
      nameDesignation: "Mrs.Shyni, AP/Mech",
      department: "GENERAL ENGINEERING",
      photoPath: "assets/img/faculty/faculty-069.jpg"
    },
    {
      sno: 70,
      auFin: "2616871989",
      aicteId: "1-44725705244",
      nameDesignation: "Dr.S. Mathumohan Prof/M.E CSE",
      department: "ME COMPUTER SCIENCE & ENGINEERING",
      photoPath: "assets/img/faculty/faculty-070.jpg"
    },
    {
      sno: 71,
      auFin: "2655451971",
      aicteId: "1-44721940858",
      nameDesignation: "Ms. Vennila AP/M.E CSE",
      department: "ME COMPUTER SCIENCE & ENGINEERING",
      photoPath: "assets/img/faculty/faculty-071.jpg"
    },
    {
      sno: 72,
      auFin: "2787732001",
      aicteId: "1-47948871782",
      nameDesignation: "Ms Gayathri AP/M.E CSE",
      department: "ME COMPUTER SCIENCE & ENGINEERING",
      photoPath: "assets/img/faculty/faculty-072.jpg"
    },
    {
      sno: 73,
      auFin: "2673231973",
      aicteId: "1-7388876728",
      nameDesignation: "Dr.RAMELA K R Prof/EST",
      department: "M.E EMBEDDED SYSTEM TECHNOLOGIES",
      photoPath: "assets/img/faculty/faculty-073.jpg"
    },
    {
      sno: 74,
      auFin: "2671301987",
      aicteId: "1-480842131",
      nameDesignation: "Mr.RAJADURAI C ASP/EST",
      department: "M.E EMBEDDED SYSTEM TECHNOLOGIES",
      photoPath: "assets/img/faculty/faculty-074.jpg"
    },
    {
      sno: 75,
      auFin: "2635521994",
      aicteId: "1-47944282100",
      nameDesignation: "Mrs.M.HALITHA PARVEEN AP/EST",
      department: "M.E EMBEDDED SYSTEM TECHNOLOGIES",
      photoPath: "assets/img/faculty/faculty-075.jpg"
    },
    {
      sno: 76,
      auFin: "2631541974",
      aicteId: "1-480586857",
      nameDesignation: "Dr.S.Meenakshi Sudarvizhi, Prof/Environmental",
      department: "M.E  - ENVIRONMENTAL ENGINEERING",
      photoPath: "assets/img/faculty/faculty-076.jpg"
    },
    {
      sno: 77,
      auFin: "2648791992",
      aicteId: "1-44723601478",
      nameDesignation: "Mr.S.Karthikeyan, AP/ Environmental",
      department: "M.E  - ENVIRONMENTAL ENGINEERING",
      photoPath: "assets/img/faculty/faculty-077.jpg"
    },
    {
      sno: 78,
      auFin: "2624051980",
      aicteId: "1-2191328439",
      nameDesignation: "Mr.B.M.Gnanasekaran ASP/Thermal",
      department: "M.E THERMAL ENGINEERING",
      photoPath: "assets/img/faculty/faculty-078.jpg"
    },
    {
      sno: 79,
      auFin: "2695561989",
      aicteId: "1-7478690848",
      nameDesignation: "Mr.H.Ganesh AP/Thermal",
      department: "M.E THERMAL ENGINEERING",
      photoPath: "assets/img/faculty/faculty-079.jpg"
    },
    {
      sno: 80,
      auFin: "2677661990",
      aicteId: "1-9508507268",
      nameDesignation: "Mrs. P. Geetha. AP/ MBA",
      department: "MBA",
      photoPath: "assets/img/faculty/faculty-080.jpg"
    },
    {
      sno: 81,
      auFin: "2697031977",
      aicteId: "1-44244435391",
      nameDesignation: "Mr.S. Arun Babu. AP/ MBA",
      department: "MBA",
      photoPath: "assets/img/faculty/faculty-081.jpg"
    },
    {
      sno: 82,
      auFin: "2614611974",
      aicteId: "1-44720439308",
      nameDesignation: "Mr.S. V. Balaji. AP/ MBA",
      department: "MBA",
      photoPath: "assets/img/faculty/faculty-082.jpg"
    },
    {
      sno: 83,
      auFin: "2612021998",
      aicteId: "1-47950532182",
      nameDesignation: "Mr.M. Yogeshwaran.AP/ MBA",
      department: "MBA",
      photoPath: "assets/img/faculty/faculty-083.jpg"
    },
    {
      sno: 84,
      auFin: "2779892000",
      aicteId: "1-47949025512",
      nameDesignation: "Ms.P.Maha Atchaya. AP/ MBA",
      department: "MBA",
      photoPath: "assets/img/faculty/faculty-084.jpg"
    },
    {
      sno: 85,
      auFin: "2753132000",
      aicteId: "1-47949022162",
      nameDesignation: "Mr.S. Mohamed Azim. AP/ MBA",
      department: "MBA",
      photoPath: "assets/img/faculty/faculty-085.jpg"
    },

  ];

  constructor(public themeService: ThemeCustomizerService) {}

  ngOnInit(): void {
    this.themeSub = this.themeService.isToggled$.subscribe(isToggled => {
      this.isToggled = isToggled;
    });
  }

  ngOnDestroy(): void {
    this.themeSub?.unsubscribe();
  }

  toggleTheme(): void {
    this.themeService.toggleTheme();
  }

  showDepartmentHeader(index: number): boolean {
    const currentDepartment = this.facultyList[index]?.department;

    if (!currentDepartment) {
      return false;
    }

    if (index === 0) {
      return true;
    }

    return currentDepartment !== this.facultyList[index - 1]?.department;
  }

  trackBySno(index: number, item: FacultyRow): number {
    return item.sno;
  }
}
